// Generated by CoffeeScript 1.12.7
(function () {
  Viewthespace.Map = (function () {
    Map.loadScript = function (callback) {
      var script;
      window.initializeGoogleMaps = callback;
      script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "//maps.googleapis.com/maps/api/js?key=" +
        googleMapsApiKey +
        "&callback=initializeGoogleMaps";
      return document.body.appendChild(script);
    };

    function Map(latitude, longitude, opts, cb) {
      var self;
      if (opts == null) {
        opts = {};
      }
      this.disabled = $("body").data("maps-disabled");
      if (this.disabled || !(latitude != null && longitude != null)) {
        return;
      }
      self = this;
      this.latitude = latitude;
      this.longitude = longitude;
      this.zoom = opts["zoom"] || 20;
      this.property_id = opts["property_id"] || "";
      Viewthespace.Map.loadScript(function () {
        self.createMap();
        return cb(self);
      });
    }

    Map.prototype.createMap = function () {
      var latlng, mapDiv;
      latlng = new google.maps.LatLng(this.latitude, this.longitude);
      this.mapOptions = {
        zoom: this.zoom,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        sensor: true,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: false,
        maxZoom: 16,
      };
      mapDiv =
        document.getElementById("map_canvas" + this.property_id) ||
        document.getElementById("map_canvas");
      this.map = new google.maps.Map(mapDiv, this.mapOptions);
      this.markerImage = new google.maps.MarkerImage(
        "/assets/vts-marker.png",
        new google.maps.Size(40, 41, new google.maps.Point(0, 0, new google.maps.Point(12, 34)))
      );
      this.shadowMarkerImage = new google.maps.MarkerImage(
        "/assets/vts-marker-shadow.png",
        new google.maps.Size(40, 41, new google.maps.Point(0, 0, new google.maps.Point(12, 34)))
      );
      this.bounds = new google.maps.LatLngBounds();
      return this.bounds.extend(latlng);
    };

    Map.prototype.addMarker = function (latitude, longitude) {
      var latlng;
      if (this.disabled) {
        return;
      }
      latlng = new google.maps.LatLng(latitude, longitude);
      this.bounds.extend(latlng);
      return new google.maps.Marker({
        position: latlng,
        map: this.map,
        icon: this.markerImage,
        shadow: this.shadowMarkerImage,
      });
    };

    Map.prototype.resize = function () {
      return google.maps.event.trigger(this.map, "resize");
    };

    Map.prototype.recenter = function () {
      return this.map.setCenter(this.mapOptions.center);
    };

    return Map;
  })();
}.call(this));
